module.exports = __webpack_public_path__ + "media/images/icon__twitter@3x-b8600fd5afc99ff3552a3cc584ed3746.png";